import type { Site } from '@/types/site';
import SiteCard from '@/components/feature/SiteCard';
import SectionHeading from '@/components/base/SectionHeading';

interface RelatedSitesProps {
  list: Site[];
}

export default function RelatedSites({ list }: RelatedSitesProps) {
  if (list.length === 0) return null;

  return (
    <section className="mt-12" data-product-shop>
      <SectionHeading
        icon="ri-links-line"
        title="相关推荐"
        subtitle="根据所属分类与标签为你关联的相似网站"
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((site) => (
          <SiteCard key={site.id} site={site} compact />
        ))}
      </div>
    </section>
  );
}